// Slugs of well-known email inboxes, backed by the email_inboxes table (see
// apiv3/config/clients/default/tables/email_inboxes.php). The slug stays the
// same across environments while the actual address behind it (the inbox's
// "name") can differ per environment (e.g. a test inbox on the testing
// server vs. the real one live) - always resolve one of these via
// useEmailInboxAddressBySlug from emailInboxesSlice rather than hardcoding
// the address.
export const EMAIL_INBOX_SLUG_KUNDENBETREUUNG = 'kundenbetreuung';
export const EMAIL_INBOX_SLUG_BUCHHALTUNG = 'buchhaltung';
export const EMAIL_INBOX_SLUG_FRANCHISE_SUPPORT = 'franchise-support';
